// @flow
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import PageTemplate from 'components/base/PageTemplate';
import CheckoutFailTemplateContainer from 'containers/checkout/CheckoutFailTemplateContainer';

type Props = {};

class CheckoutFail extends Component<Props> {
  render() {
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          <Helmet>
            <title>구매 실패 | 캐시바이</title>
          </Helmet>
          <CheckoutFailTemplateContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default CheckoutFail;



// WEBPACK FOOTER //
// ./src/pages/CheckoutFail.js